module.exports = __webpack_public_path__ + "img/lnb_video_game.590cc038.png";